"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformWebhookApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const SdWebhookSignature_1 = require("../util/SdWebhookSignature");
/**
 * Webhook calls.
 */
class SdPlatformWebhookApi {
    /**
     * @param { ShapeDiverSDKContext } __context
     */
    constructor(__context) {
        this.__context = __context;
        this.__commonPath = "webhook/v1";
        this.__api = __context.api;
    }
    __getPath(pathSufix = null) {
        return `${this.__commonPath}/${pathSufix}`;
    }
    __resolveRequestConfig(options) {
        return {
            username: options.username,
            password: options.password,
            access_token: options.bearer_access_token,
            basic_access_token: options.basic_access_token,
            client_id: this.__context.config.clientId
        };
    }
    /**
     * Webhook which notifies the platform of chargebee events.
     * @param auth {@link SdPlatformWebhookBasicAuth}
     * @param body {@link SdPlatformRequestWebhookChargebeeEvent}
     * @returns
     */
    chargebeeEvent(auth, body) {
        return this.__api.post(SdPlatformRequestId_1.RequestId.WebhookChargebeeEvent, this.__getPath("chargebee_event"), body, this.__resolveRequestConfig({
            username: auth.username,
            password: auth.password
        }));
    }
    /**
    * Model message webhook call - send a message to the owner of a model.
    * @param auth {@link SdPlatformWebhookTokenAuth}
    * @param body {@link SdPlatformRequestWebhookModelMessage}
    * @returns
    */
    modelMessage(auth, body) {
        return this.__api.post(SdPlatformRequestId_1.RequestId.WebhookModelMessage, this.__getPath("model_message"), body, this.__resolveRequestConfig({
            bearer_access_token: auth.bearer_access_token,
            basic_access_token: auth.basic_access_token,
        }));
    }
    /**
    * Notification webhook call - create a notification related to a model.
    * @param auth {@link SdPlatformWebhookTokenAuth}
    * @param body {@link SdPlatformRequestWebhookNotification}
    * @returns
    */
    notification(auth, body) {
        return this.__api.post(SdPlatformRequestId_1.RequestId.WebhookNotification, this.__getPath("notifications"), body, this.__resolveRequestConfig({
            bearer_access_token: auth.bearer_access_token,
            basic_access_token: auth.basic_access_token,
        }));
    }
    /**
     * Model computation webhook call - trigger a computation on a model.
     * @param identifier - the webhook identifier of a user
     * @param secret - the webhook secret of a user
     * @param modelSlug - the slug of the model
     * @param body - the body of the request, usually key value pair of model parameters
     *
     * {@link https://app.shapediver.com/api/documentation#/webhooks/630563fd0538d167bea7e9ddfa96be3c See Webhook Documentation}
     *
     * Mapping of parameters:
     * - if the parameter’s displayname or name is “payload”, complete request body is used as a JSON string for this parameter.
     * - if property of the request body name matches the parameter id, value of the property is used.
     * - if parameter has "displayname" and body has property with the same name, value of the property is used. If parameter name contains dots, searched for corresponding nested property.
     * - if parameter has "name" and body has property with the same name, value of the property is used. If parameter name contains dots, searched for corresponding nested property.
     * - if no matching property is found by previous case, parameter from the request body is ignored.
     */
    modelComputation(identifier, secret, modelSlug, body) {
        var path = this.__getPath(`${identifier}/${modelSlug}/output`);
        const header = (0, SdWebhookSignature_1.createWebhookSignature)(secret, body);
        return this.__api.post(SdPlatformRequestId_1.RequestId.WebhookModelComputation, path, body, this.__resolveRequestConfig({}), {
            "X-WEBHOOK-SIGNATURE": header
        });
    }
    /**
     * Model export webhook call - trigger an export on a model.
     * @param identifier - the webhook identifier of a user
     * @param secret - the webhook secret of a user
     * @param modelSlug - the slug of the model
     * @param exportId - the id of the export
     * @param body - the body of the request, usually key value pair of model parameters
     *
     * {@link https://app.shapediver.com/api/documentation#/webhooks/630563fd0538d167bea7e9ddfa96be3c See Webhook Documentation}
     *
     * Mapping of parameters:
     * - if the parameter’s displayname or name is “payload”, complete request body is used as a JSON string for this parameter.
     * - if property of the request body name matches the parameter id, value of the property is used.
     * - if parameter has "displayname" and body has property with the same name, value of the property is used. If parameter name contains dots, searched for corresponding nested property.
     * - if parameter has "name" and body has property with the same name, value of the property is used. If parameter name contains dots, searched for corresponding nested property.
     * - if no matching property is found by previous case, parameter from the request body is ignored.
     */
    modelExport(identifier, secret, modelSlug, exportId, body) {
        var path = this.__getPath(`${identifier}/${modelSlug}/export/${exportId}`);
        const header = (0, SdWebhookSignature_1.createWebhookSignature)(secret, body);
        return this.__api.post(SdPlatformRequestId_1.RequestId.WebhookModelExport, path, body, this.__resolveRequestConfig({}), {
            "X-WEBHOOK-SIGNATURE": header
        });
    }
}
exports.SdPlatformWebhookApi = SdPlatformWebhookApi;
//# sourceMappingURL=SdPlatformWebhookApi.js.map